<template>


  <head>

    <meta charset="utf-8"/>
    <title>Desk Birdy | Medical Certificates</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

  </head>

  <body @contextmenu.prevent data-sidebar="dark">


  <!-- Begin page -->
  <div id="layout-wrapper">


    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="page-header-box">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="page-icon">
                      <i class="mdi mdi-file-clock-outline"></i>
                    </div>
                    <div class="ms-3">
                      <h4 class="page-title mb-1">Unpaid Medical Invoices</h4>
                      <p class="page-breadcrumb mb-0">
                        <span>Dashboard</span>
                        <i class="mdi mdi-chevron-right mx-1"></i>
                        <span>Certificates & Licenses</span>
                        <i class="mdi mdi-chevron-right mx-1"></i>
                        <span>Pending Invoices</span>
                      </p>
                    </div>
                  </div>
                  <div class="header-stats-row d-flex">
                    <div class="header-stat-box">
                      <span class="stat-number">{{ numberFormat(totalBusiness) }}</span>
                      <span class="stat-text">PENDING INVOICES</span>
                    </div>
                    <div class="header-stat-box stat-warning">
                      <span class="stat-number">KES {{ numberFormat(totalAmount) }}</span>
                      <span class="stat-text">UNPAID AMOUNT</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarMedical/>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <!-- Card Header -->
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                      <h5 class="card-title mb-1">
                        <i class="mdi mdi-receipt-text-outline me-2 text-warning"></i>
                        Pending Payment Invoices
                      </h5>
                      <p class="text-muted mb-0 small">Medical certificate invoices awaiting payment</p>
                    </div>
                    <div class="header-search-box">
                      <div class="position-relative">
                        <i class="mdi mdi-magnify search-icon"></i>
                        <input
                            v-model="search"
                            type="text"
                            class="form-control search-input"
                            placeholder="Search by name, ID, bill number..."
                        >
                        <button v-if="search" @click="search = ''" class="btn-clear">
                          <i class="mdi mdi-close"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card Body -->
                <div class="card-body p-0">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-3 text-muted">Loading records...</p>
                  </div>

                  <!-- Empty State -->
                  <div v-if="pendingInvoicing.length < 1 && loading === false" class="text-center py-5">
                    <img src="assets/images/no-results.png" class="mb-4" style="height: 120px;" alt="No results"/>
                    <h5>No Pending Invoices</h5>
                    <p class="text-muted">All invoices have been paid or no invoices match your search criteria.</p>
                    <button v-if="search" @click="search = ''" class="btn btn-outline-primary btn-sm">
                      <i class="mdi mdi-refresh me-1"></i> Clear Search
                    </button>
                  </div>

                  <!-- Data Table -->
                  <div v-if="pendingInvoicing.length > 0 && !loading" class="table-responsive">
                    <table class="table table-hover table-striped mb-0">
                      <thead class="table-light">
                      <tr>
                        <th>APPLICANT</th>
                        <th>INVOICE DETAILS</th>
                        <th>DATE INVOICED</th>
                        <th>INVOICED BY</th>
                        <th>AMOUNT</th>
                        <th>STATUS</th>
                        <th class="text-end">ACTIONS</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in pendingInvoicing" :key="index">
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-circle">
                              {{ getInitials(item.name) }}
                            </div>
                            <div class="ms-3">
                              <h6 class="mb-0 fw-semibold">{{ item.name }}</h6>
                              <small class="text-muted">
                                <i class="mdi mdi-card-account-details-outline me-1"></i>
                                ID: {{ item.idNo }}
                              </small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="fw-medium text-primary">{{ item.billNo }}</span>
                            <br>
                            <small class="text-muted">Medical Certificate</small>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ formatDate(item.dateCreated) }}</span>
                            <br>
                            <small class="text-muted">
                              {{ formattedTime(item.dateCreated) }} ({{ formatTimeAgo(item.dateCreated) }})
                            </small>
                          </div>
                        </td>
                        <td>
                          <span>{{ item.names }}</span>
                        </td>
                        <td>
                          <span class="fw-semibold">KES {{ numberFormat(item.billTotal) }}</span>
                        </td>
                        <td>
                            <span class="badge bg-warning text-dark">
                              <i class="mdi mdi-clock-outline me-1"></i>
                              Unpaid
                            </span>
                        </td>
                        <td>
                          <div class="d-flex justify-content-end gap-2">
                            <button
                                @click="getBusiness(item.billNo, item.businessID)"
                                class="btn btn-sm btn-light"
                                data-bs-toggle="modal"
                                data-bs-target=".receipting-modal"
                                title="View Details"
                            >
                              <i class="mdi mdi-eye-outline"></i>
                            </button>
                            <button
                                @click="printBill(item.billNo)"
                                class="btn btn-sm btn-outline-success"
                                title="Print Invoice"
                            >
                              <i class="mdi mdi-printer-outline"></i>
                            </button>
                            <button
                                @click="getBusiness(item.billNo, item.businessID)"
                                class="btn btn-sm btn-outline-primary"
                                data-bs-toggle="modal"
                                data-bs-target=".SMS-modal"
                                title="Resend SMS"
                            >
                              <i class="mdi mdi-message-text-outline"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Table Footer -->
                  <div v-if="!loading && pendingInvoicing.length > 0" class="card-footer bg-light border-top d-flex justify-content-between align-items-center">
                    <span class="text-muted">
                      Showing <strong>{{ pendingInvoicing.length }}</strong> pending invoices
                    </span>
                    <div>
                      <span class="me-3">
                        <i class="mdi mdi-file-document-multiple-outline me-1"></i>
                        {{ numberFormat(totalBusiness) }} Total
                      </span>
                      <span class="text-warning fw-semibold">
                        <i class="mdi mdi-cash me-1"></i>
                        KES {{ numberFormat(totalAmount) }} Unpaid
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Details Modal -->
      <div class="modal fade receipting-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header modal-header-white">
              <div class="d-flex align-items-center">
                <div class="modal-header-icon">
                  <i class="mdi mdi-account-details"></i>
                </div>
                <div class="ms-3">
                  <h5 class="modal-title mb-0">Invoice Details</h5>
                  <small class="text-muted">{{ business.businessName || 'Applicant Details' }}</small>
                </div>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <!-- Timeline -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-timeline-clock-outline me-2"></i>
                  Processing Timeline
                </h6>
                <div class="timeline-row">
                  <div class="timeline-step completed">
                    <div class="timeline-dot">
                      <i class="mdi mdi-check"></i>
                    </div>
                    <div class="timeline-label">Invoicing</div>
                    <div class="timeline-date">{{ formatDate(billDetail.dateCreated) }}</div>
                  </div>
                  <div class="timeline-line"></div>
                  <div class="timeline-step active">
                    <div class="timeline-dot">
                      <i class="mdi mdi-clock-outline"></i>
                    </div>
                    <div class="timeline-label">Payment</div>
                    <div class="timeline-date">Pending</div>
                  </div>
                  <div class="timeline-line"></div>
                  <div class="timeline-step">
                    <div class="timeline-dot">
                      <i class="mdi mdi-clock-outline"></i>
                    </div>
                    <div class="timeline-label">Approval</div>
                    <div class="timeline-date">-</div>
                  </div>
                </div>
              </div>

              <!-- Business Owner -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-account-outline me-2"></i>
                  Business Owner
                </h6>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">OWNER'S NAME</label>
                    <p class="mb-0 fw-medium">{{ business.fullNames || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">ID NUMBER</label>
                    <p class="mb-0 fw-medium">{{ business.ownerID || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">PHONE</label>
                    <p class="mb-0 fw-medium">{{ business.ownerPhone || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">EMAIL</label>
                    <p class="mb-0 fw-medium">{{ business.ownerEmail || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">KRA PIN</label>
                    <p class="mb-0 fw-medium">{{ business.kraPin || '-' }}</p>
                  </div>
                </div>
              </div>

              <!-- Business Details -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-briefcase-outline me-2"></i>
                  Business Details
                </h6>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">BUSINESS NAME</label>
                    <p class="mb-0 fw-medium">{{ business.businessName || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">BUSINESS CATEGORY</label>
                    <p class="mb-0 fw-medium">{{ business.businessCategory || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">SUB CATEGORY</label>
                    <p class="mb-0 fw-medium">{{ business.businessSubCategory || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">BUSINESS ID</label>
                    <p class="mb-0 fw-medium font-monospace">{{ business.businessID || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">SUB COUNTY</label>
                    <p class="mb-0 fw-medium">{{ business.subCountyName || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">WARD</label>
                    <p class="mb-0 fw-medium">{{ business.wardName || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">PHYSICAL ADDRESS</label>
                    <p class="mb-0 fw-medium">{{ business.physicalAddress || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">PLOT NUMBER</label>
                    <p class="mb-0 fw-medium">{{ business.plotNumber || '-' }}</p>
                  </div>
                </div>
              </div>

              <!-- Invoice Details -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-receipt-text-outline me-2"></i>
                  Invoice Details
                </h6>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">DATE INVOICED</label>
                    <p class="mb-0 fw-medium">{{ formatDate(billDetail.dateCreated) }} {{ formattedTime(billDetail.dateCreated) }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">INVOICED BY</label>
                    <p class="mb-0 fw-medium">{{ billDetail.names || '-' }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">PAYMENT STATUS</label>
                    <p class="mb-0">
                      <span class="badge bg-warning text-dark">{{ billDetail.status || 'Unpaid' }}</span>
                    </p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">AMOUNT</label>
                    <p class="mb-0 fw-semibold text-danger">KES {{ numberFormat(billDetail.detailAmount) }}</p>
                  </div>
                </div>
              </div>

              <!-- Description -->
              <div class="section-block" v-if="billDetail.description">
                <h6 class="section-title">
                  <i class="mdi mdi-clipboard-text-outline me-2"></i>
                  Description
                </h6>
                <div class="findings-box">
                  {{ billDetail.description }}
                </div>
              </div>
            </div>

            <div class="modal-footer bg-light">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                <i class="mdi mdi-close me-1"></i> Close
              </button>
              <button @click="printBill(billDetail.billNo)" class="btn btn-success">
                <i class="mdi mdi-printer-outline me-1"></i> Print Invoice
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- SMS Modal -->
      <div class="modal fade SMS-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header modal-header-white">
              <div class="d-flex align-items-center">
                <div class="modal-header-icon icon-info">
                  <i class="mdi mdi-message-text-outline"></i>
                </div>
                <div class="ms-3">
                  <h5 class="modal-title mb-0">Resend Invoice SMS</h5>
                  <small class="text-muted">Send payment reminder</small>
                </div>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="sms-info-card">
                <div class="mb-3">
                  <label class="form-label text-muted small mb-1">SEND TO</label>
                  <p class="mb-0 fw-semibold">{{ business.ownerPhone }}</p>
                  <p class="mb-0 text-muted small">{{ business.ownerEmail }}</p>
                </div>
                <hr>
                <div class="mb-3">
                  <label class="form-label text-muted small mb-1">INVOICE NUMBER</label>
                  <p class="mb-0 fw-semibold text-primary font-monospace">{{ billDetail.billNo }}</p>
                </div>
                <div class="mb-0">
                  <label class="form-label text-muted small mb-1">DATE INVOICED</label>
                  <p class="mb-0">{{ formatDate(billDetail.dateCreated) }}, {{ formattedTime(billDetail.dateCreated) }}</p>
                </div>
              </div>
              <div class="alert alert-info mt-3 mb-0">
                <i class="mdi mdi-information-outline me-2"></i>
                A notification will be sent to the client via SMS containing payment details.
              </div>
            </div>
            <div class="modal-footer bg-light">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button @click="resendMessage()" data-bs-dismiss="modal" class="btn btn-primary">
                <i class="mdi mdi-send me-1"></i> Send SMS
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  <div class="rightbar-overlay"></div>

  </body>


</template>

<script>
/* eslint-disable */
import { defineComponent } from "vue";
import NavigationBar from "@/components/Navigation.vue";
import ToolBarMedical from "@/components/medical/ToolBarMedical.vue";
import { execute, biller, health } from "@/api";

export default {
  name: "cert-medical-pending",
  components: { ToolBarMedical, NavigationBar },

  data() {
    return {
      loading: false,
      search: '',
      pendingInvoicing: [],
      totalBusiness: 0,
      totalAmount: 0,
      business: {
        id: null,
        businessID: null,
        businessName: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null,
        buildingName: null,
        buildingOccupancy: null,
        floorNo: null,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        feeID: null,
        businessEmail: null,
        postalAddress: null,
        postalCode: null,
        businessPhone: null,
        contactPersonNames: null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames: null,
        ownerID: null,
        ownerPhone: null,
        ownerEmail: null,
        kraPin: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: 0.0,
        lng: 0.0
      },
      billDetail: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription: null,
        costCenterNo: null,
        accountNo: null,
        description: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        wardID: null,
        subCountyID: null,
        subCountyName: null,
        wardName: null,
        status: null,
        dateCreated: null,
        zone: null,
        departmentID: null,
        department: null,
        idNo: null,
        phoneNumber: null,
        names: null,
        customerPhoneNumber: null,
        category: null
      }
    }
  },

  mounted() {
    this.getPendingInvoicesMedical();
    this.menuAccess();
  },

  watch: {
    search() {
      this.getPendingInvoicesMedical();
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Cert Medical Pending");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch((e) => console.error(e));
    },

    getInitials(name) {
      if (!name) return '?';
      const parts = name.split(' ');
      return parts.length >= 2
          ? (parts[0][0] + parts[1][0]).toUpperCase()
          : name.substring(0, 2).toUpperCase();
    },

    formatTimeAgo(dateString) {
      const currentDate = new Date();
      const date = new Date(dateString);
      const timeDifference = currentDate - date;
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

      if (daysDifference === 0) return 'Today';
      if (daysDifference === 1) return 'Yesterday';
      return `${daysDifference} Days Ago`;
    },

    formattedTime(originalTime) {
      const parsedTime = new Date(originalTime);
      return parsedTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const date = new Date(dateString);
      return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    getPendingInvoicesMedical() {
      this.loading = true;
      this.pendingInvoicing = [];

      const data = new FormData();
      data.append("function", "getPendingInvoicesMedical");
      data.append("keyword", this.search);

      execute(data, health)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.pendingInvoicing = res.data.data.pendingInvoicing || [];
              this.totalBusiness = this.pendingInvoicing.length;
              this.totalAmount = this.pendingInvoicing.reduce((acc, cur) => {
                const amount = Number(cur.billTotal);
                return !isNaN(amount) ? acc + amount : acc;
              }, 0);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
          });
    },

    getBusiness(billNo, businessID) {
      const data = new FormData();
      data.append("function", "getBusiness");
      data.append("businessID", businessID);
      data.append("billNo", billNo);

      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              this.business = res.data.data.business;
              this.billDetail = res.data.data.bill.billDetails;
            }
          })
          .catch((e) => console.error(e));
    },

    resendMessage() {
      const data = new FormData();
      data.append("function", "resendMessage");
      data.append("customerPhoneNumber", this.business.ownerPhone);
      data.append("incomeTypePrefix", this.billDetail.incomeTypePrefix);
      data.append("billNo", this.billDetail.billNo);
      data.append("name", this.business.businessName);

      execute(data, biller)
          .then((res) => {
            alert(res.data.message);
          })
          .catch((e) => console.error(e));
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.page-icon {
  width: 50px;
  height: 50px;
  background: #2a3f54;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #2a3f54;
}

.page-breadcrumb {
  font-size: 13px;
  color: #6c757d;
}

.page-breadcrumb span:last-child {
  color: #2a3f54;
  font-weight: 500;
}

.header-stats-row {
  gap: 12px;
}

.header-stat-box {
  background: #2a3f54;
  border-radius: 8px;
  padding: 12px 20px;
  text-align: center;
  min-width: 140px;
}

.header-stat-box.stat-warning {
  background: #f0ad4e;
}

.stat-number {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.stat-text {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 0.5px;
  margin-top: 2px;
}

/* Search Box */
.header-search-box {
  min-width: 300px;
}

.header-search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  font-size: 18px;
}

.header-search-box .search-input {
  padding-left: 40px;
  padding-right: 36px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  height: 40px;
}

.header-search-box .search-input:focus {
  border-color: #2a3f54;
  box-shadow: 0 0 0 2px rgba(42, 63, 84, 0.1);
}

.header-search-box .btn-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #adb5bd;
  cursor: pointer;
  padding: 4px;
}

.header-search-box .btn-clear:hover {
  color: #495057;
}

/* Avatar Circle */
.avatar-circle {
  width: 40px;
  height: 40px;
  background: #2a3f54;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}

/* Table Styling */
.table thead th {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  padding: 12px 16px;
  white-space: nowrap;
}

.table tbody td {
  padding: 14px 16px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f5;
}

.table tbody tr:hover {
  background: #f8f9fa;
}

/* Modal Styling */
.modal-header-white {
  background: #fff;
  color: #2a3f54;
  border-bottom: 1px solid #e9ecef;
  padding: 16px 20px;
}

.modal-header-icon {
  width: 44px;
  height: 44px;
  background: #2a3f54;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
}

.modal-header-icon.icon-info {
  background: #17a2b8;
}

/* Section Blocks */
.section-block {
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
}

.section-block:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #2a3f54;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #2a3f54;
}

/* Timeline */
.timeline-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 20px;
}

.timeline-step {
  text-align: center;
  flex: 1;
  position: relative;
}

.timeline-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  color: #adb5bd;
  font-size: 16px;
}

.timeline-step.completed .timeline-dot {
  background: #28a745;
  color: #fff;
}

.timeline-step.active .timeline-dot {
  background: #f0ad4e;
  color: #fff;
}

.timeline-label {
  font-weight: 600;
  font-size: 13px;
  color: #495057;
}

.timeline-date {
  font-size: 12px;
  color: #adb5bd;
}

.timeline-line {
  flex: 0 0 60px;
  height: 2px;
  background: #e9ecef;
  margin-top: 18px;
}

/* Findings Box */
.findings-box {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px 16px;
  border-left: 3px solid #2a3f54;
  font-size: 14px;
  color: #495057;
}

/* SMS Info Card */
.sms-info-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

/* Card Footer */
.card-footer {
  padding: 12px 16px;
  font-size: 13px;
}

/* Responsive */
@media (max-width: 992px) {
  .header-search-box {
    min-width: 100%;
    margin-top: 16px;
  }

  .header-stats-row {
    width: 100%;
    justify-content: flex-end;
    margin-top: 16px;
  }
}

@media (max-width: 768px) {
  .page-header-box {
    padding: 16px;
  }

  .page-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .page-title {
    font-size: 16px;
  }

  .header-stat-box {
    padding: 10px 16px;
    min-width: 120px;
  }

  .stat-number {
    font-size: 16px;
  }

  .timeline-row {
    padding: 0;
  }

  .timeline-line {
    flex: 0 0 30px;
  }
}
</style>